import { render, staticRenderFns } from "./index.vue?vue&type=template&id=309d177f&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=309d177f&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309d177f')) {
      api.createRecord('309d177f', component.options)
    } else {
      api.reload('309d177f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=309d177f&lang=pug", function () {
      api.rerender('309d177f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/privateBookingClassRecordModal/index.vue"
export default component.exports